<template>
  <el-dialog :title='dialogTitle' :visible.sync='dialogVisible' :close-on-click-modal='false'
             @close='dialogClose' width='500px'>
    <el-form :model='form' label-width='130px' label-position='right' ref='ruleForm' class='mt20'>
      <el-form-item label='交单数量：'>
        <el-input v-model='total' size='mini' disabled placeholder='请输入交单数量' />
      </el-form-item>
      <el-form-item label='收单备注：'>
        <el-input v-model='form.receiveRemarks' size='mini' placeholder='请输入收单备注' />
      </el-form-item>
      <div class='flex-center-center mt20'>
        <el-button size='medium' class='searchBtn' :loading='submitLoading' @click='submit'>确认
        </el-button>
        <el-button size='medium' class='resetBtn' @click='dialogClose'>关闭</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
  import {
    getName,
    getSupplierById,
    getTaskType,
    portWarehouseCostAdd,
    portWarehouseCostUpdate,
  } from '@/service/warehouse';
  import { customerInfoSelectList } from '@/service/financial';
  import { getModelList } from '@/service/vehiclelog';
  import BatchImport from '@/components/batchImport';
  import { receiptConfirm } from '@/service/receipt';

  export default {
    name: 'supplierDeliveryReceiptForm',
    components: {
      BatchImport,
    },
    data() {
      return {
        dialogVisible: false,
        dialogTitle: '确认收单',
        defaultForm: {},
        form: {
          ids: '',
          receiveRemarks: '',
        },
        total: 0,
        submitLoading: false,
      };
    },
    mounted() {
      this.defaultForm = JSON.parse(JSON.stringify(this.form));
    },
    methods: {
      dialogOpen(ids, total) {
        this.form = JSON.parse(JSON.stringify(this.defaultForm));
        this.form.ids = ids;
        this.total = total;
        this.dialogVisible = true;
      },
      dialogClose() {
        this.dialogVisible = false;
        this.$refs.ruleForm.resetFields();
      },
      submit() {
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            this.submitLoading = true;
            const {
              status,
              message,
            } = await receiptConfirm(this.form);
            this.submitLoading = false;
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            this.$emit('searchBtn');
            this.dialogClose();
          }
        });
      },
    },
  };
</script>

<style lang='scss' scoped></style>
